// Copyright (c) 2016 Deere & Company

import KeyValuePair from './key-value-pair';
import t from 'tcomb';

const TcsmSettings = t.struct({
    allowedSpaLevels: t.list(KeyValuePair, 'Allowed SPA Levels'),
    selectedSpaLevels: t.list(KeyValuePair, 'Selected SPA Levels'),
    user: t.String
}, {
    name: 'TcsmSettings',
    strict: true
});

export const getDefaultState = () => new TcsmSettings({
    allowedSpaLevels: [],
    selectedSpaLevels: [],
    user: ''
});

export default TcsmSettings;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/tcsm-settings.js